// extracted by mini-css-extract-plugin
export default {"header-menu":"HeaderMenuShared_header-menu__JZFUb","active":"HeaderMenuShared_active__tBvCN"};